module.exports = __webpack_public_path__ + "img/demo1.1efe84dc.jpg";